import { translation as enDictionary } from './en.js';
import { translation as ukDictionary } from './uk.js';
/**
 * A reference to the namespace of the translation resources.
 * This namespace is used to access the translation resources in the i18next instance.
 *
 * @internal
 */
export const PACKAGE_NAMESPACE = 'sdkRestClient';
export const resources = {
    en: enDictionary,
    uk: ukDictionary,
};
//# sourceMappingURL=index.js.map